// extracted by mini-css-extract-plugin
export default {"container":"fK-z","header":"gK-z","details":"hK-z","link":"iK-z"};